export const ANNOTATE_FILES_INVALIDATE = "ANNOTATE_FILES_INVALIDATE";
export const ANNOTATE_FILES_REQUEST = "ANNOTATE_FILES_REQUEST";
export const ANNOTATE_FILES_SUCCESS = "ANNOTATE_FILES_SUCCESS";
export const ANNOTATE_FILES_ERROR = "ANNOTATE_FILES_ERROR";
export const ANNOTATE_FILES_FETCH_REQUEST = "ANNOTATE_FILES_FETCH_REQUEST";
export const ANNOTATE_FILES_FETCH_SUCCESS = "ANNOTATE_FILES_FETCH_SUCCESS";
export const ANNOTATE_FILES_FETCH_ERROR = "ANNOTATE_FILES_FETCH_ERROR";
export const VERIFY_S3_UPLOAD = "VERIFY_S3_UPLOAD";
export const ANNOTATE_CASTS_FETCH_REQUEST = "ANNOTATE_CASTS_FETCH_REQUEST";
export const ANNOTATE_CASTS_FETCH_SUCCESS = "ANNOTATE_CASTS_FETCH_SUCCESS";
export const ANNOTATE_CASTS_FETCH_ERROR = "ANNOTATE_CASTS_FETCH_ERROR";
export const ANNOTATE_CASTS_SET_MATCHED_FORM =
  "ANNOTATE_CASTS_SET_MATCHED_FORM";
export const ANNOTATE_CASTS_UPDATE_MATCHED_FORM =
  "ANNOTATE_CASTS_UPDATE_MATCHED_FORM";
export const ANNOTATE_CASTS_UPDATE_CAST = "ANNOTATE_CASTS_UPDATE_CAST";
export const ANNOTATE_MODAL_OPEN = "ANNOTATE_MODAL_OPEN";
export const ANNOTATE_MODAL_CLOSE = "ANNOTATE_MODAL_CLOSE";
export const ANNOTATE_MODAL_SET_CAST = "ANNOTATE_MODAL_SET_CAST";
export const ANNOTATE_MODAL_SET_FORMS = "ANNOTATE_MODAL_SET_FORMS";
export const ANNOTATE_MODAL_SET_SELECTED = "ANNOTATE_MODAL_SET_SELECTED";
export const CHART_MODAL_OPEN = "CHART_MODAL_OPEN";
export const CHART_MODAL_CLOSE = "CHART_MODAL_CLOSE";
export const MAP_MODAL_OPEN = "MAP_MODAL_OPEN";
export const MAP_MODAL_CLOSE = "MAP_MODAL_CLOSE";
export const CHART_MODAL_SET_CAST = "CHART_MODAL_SET_CAST";
export const CHART_MODAL_UPDATE_CAST = "CHART_MODAL_UPDATE_CAST";
export const MAP_MODAL_SET_CAST = "MAP_MODAL_SET_CAST";
export const MAP_MODAL_SET_FORM = "MAP_MODAL_SET_FORM";
export const MAP_SITE_DATA_FETCH_REQUEST = "MAP_SITE_DATA_FETCH_REQUEST";
export const MAP_SITE_DATA_FETCH_SUCCESS = "MAP_SITE_DATA_FETCH_SUCCESS";
export const MAP_SITE_DATA_FETCH_ERROR = "MAP_SITE_DATA_FETCH_ERROR";
export const ANNOTATE_ADD_FILE_TO_ANNOTATE = "ANNOTATE_ADD_FILE_TO_ANNOTATE";
export const ANNOTATE_REMOVE_FILE_TO_ANNOTATE =
  "ANNOTATE_REMOVE_FILE_TO_ANNOTATE";
export const CHART_DATA_FETCH_REQUEST = "CHART_DATA_FETCH_REQUEST";
export const CHART_DATA_FETCH_SUCCESS = "CHART_DATA_FETCH_SUCCESS";
export const CHART_DATA_FETCH_ERROR = "CHART_DATA_FETCH_ERROR";
export const ANNOTATE_SNACKBAR_CLOSE = "ANNOTATE_SNACKBAR_CLOSE";
export const ANNOTATE_SNACKBAR_OPEN = "ANNOTATE_SNACKBAR_OPEN";
export const SIGN_OUT_COMPLETE = "SIGN_OUT_COMPLETE";
export { WORKAREA_SET } from "features/workarea/constants";
export { ORGANIZATION_SET } from "features/organization/constants";
